import { defineNuxtRouteMiddleware, landingPageRedirect, navigateTo, useUserInfo } from '#imports'

export default defineNuxtRouteMiddleware((to) => {
    if (!import.meta.server) return

    const { isExisting } = useUserInfo()
    const path = landingPageRedirect(to, isExisting.value)
    if (!path) return

    return navigateTo({ path, query: to.query }, { redirectCode: 302 })
})
